import * as yup from "yup";
import { formatCurrencyNoDecimal } from "../utilities/numericFormat.js";
import { criticalIllnessCover } from "./criticalIllnessAndTraumaCover.js";
import { permanentDisabilityCover } from "./permanentDisabilityCover.js";
// import { LIFE_INSURANCE_MIN, LIFE_INSURANCE_MAX } from "./sharedConstValues.js";

// Life cover
const LIFE_COVER_REQUIRED = "Life Insurance cover is required";

//** buildCoverSchema is used for both Select Cover and Quote Summary  */
export const buildCoverSchema = (person) => {
  return {
    ...lifeCoverConditions(person),
    ...criticalIllnessCover(person),
    ...permanentDisabilityCover(person),
    ...buildTermsAndConditions(person),
  };
};

export const buildQuoteSummarySchema = (person) => {
  return {
    ...lifeCoverConditions(person),
    ...criticalIllnessCover(person),
    ...permanentDisabilityCover(person),
  };
};

const lifeCoverConditions = (person) => {
  const personDetails = person;
  return {
    [`${person}_lifeCover`]: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .nullable()
      .required(LIFE_COVER_REQUIRED)
      .min(
        yup.ref("$" + personDetails + "_minLifeCover"),
        ({ min }) => `Minimum cover required is ${formatCurrencyNoDecimal(min)}`
      )
      .max(
        yup.ref("$" + personDetails + "_maxLifeCover"),
        ({ max }) => `Maximum cover required is ${formatCurrencyNoDecimal(max)}`
      ),
  };
};

//* T&Cs are only required on Select cover and not Quote Summary
const buildTermsAndConditions = (person) => {
  return {
    [`${person}_termsAndConditions`]: yup
      .bool()
      .oneOf([true], "The checkbox must be checked")
      .required("The checkbox is required"),
  };
};

export const buildSchemaSelectCover = (person) => {
  return buildCoverSchema(person);
};
